export default __webpack_public_path__ + "static/media/bro.27b130fb.svg";